import * as R from 'ramda';
import { IJsonQuery } from '../../../utils/jsonQuery';
import { TReduxActions } from '../../../types/redux';
import { FILTERS, IFilter, IAvailableFilters } from '../../../constants/filters';
import { defaultState } from './defaultState';

export function clearReducer(jsonQuery: IJsonQuery = defaultState, action: TReduxActions): IJsonQuery {
  if (action.type.startsWith('filters/')) {
    let nextJsonQuery = R.clone(jsonQuery);
    Object.keys(FILTERS)
      .map(key => FILTERS[key as keyof IAvailableFilters])
      .forEach((filter: IFilter) => {
        if (filter.clear && !filter.availability(nextJsonQuery)) {
          nextJsonQuery = filter.clear(nextJsonQuery);
        }
      });

    return nextJsonQuery;
  }

  return jsonQuery;
}
